import React from "react";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";

import mapleAnimation from "../../assets/lottie/canadian-maple-leaf.json";
import "../../styles/globle.css";

const AuthNavbar: React.FC = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 w-full bg-[#1C1F26] border-b border-[#272B34] shadow-sm">
      <div className="w-full max-w-[1280px] mx-auto pl-[12px] md:pl-[8px]">
        <div className="h-[55px] md:h-[64px] flex items-center sign-in-header md:pt-[4px] md:pb-[3px]">
          {/* Logo + Text Block */}
          <a
            href="https://prep2pass.ca"
            className="flex items-center cursor-pointer"
            
          >

            {/* Lottie Animation */}
            <div className="w-[57px] h-[57px] md:w-[56px] md:h-[55px] flex items-center justify-center">
              <Lottie
                animationData={mapleAnimation}
                loop={true}
                autoplay={true}
              />
            </div>

            {/* Brand name */}
            <a
              className="text-white font-bold leading-none login-header-logo"
            >
              Prep
              <span className="text-[#005FCC] logo-span">2</span>
              Pass
            </a>

          </a>
        </div>
      </div>
    </nav>
  );
};

export default AuthNavbar;
